module.exports = __webpack_public_path__ + "media/images/shark/Francis-0bfc1aa0aeac50f0576589f25d81af66.jpg";